import { AccountBalance, DocumentScanner } from "@mui/icons-material";
import { ListItemIcon } from "@mui/material";
import React from "react";

import Colors from "../../../../../../../global/Colors";
import { NOTIFICATION_TYPES } from "../utils/types";

import NotificationTooltip from "./NotificationTooltip";
import TooltipContentCase from "./TooltipContentCase";
import TooltipContentLawFirm from "./TooltipContentLawFirm";

export default function NotificationsItemtype({ item }) {
  const renderIcon = (item) => {
    switch (item.type) {
      case NOTIFICATION_TYPES.CASE:
        return <DocumentScanner />;
      case NOTIFICATION_TYPES.LAW_FIRM:
        return <AccountBalance />;
      default:
        return;
    }
  };
  const renderName = (item) => {
    switch (item.type) {
      case NOTIFICATION_TYPES.CASE:
        return item.client_name;
      case NOTIFICATION_TYPES.LAW_FIRM:
        return item.name;
      default:
        return;
    }
  };
  const renderTooltipContent = (item) => {
    switch (item.type) {
      case NOTIFICATION_TYPES.CASE:
        return <TooltipContentCase item={item} />;
      case NOTIFICATION_TYPES.LAW_FIRM:
        return <TooltipContentLawFirm item={item} />;
      default:
        return;
    }
  };

  const renderNotificationItem = (item) => {
    return (
      <NotificationTooltip title={renderTooltipContent(item)}>
        <div className="my-0 flex inline-flex items-center">
          <div className="mr-2 w-[20px]">
            <ListItemIcon sx={{ color: Colors.black }}>{renderIcon(item)}</ListItemIcon>
          </div>
          <div className="text-black">{renderName(item)}</div>
        </div>
      </NotificationTooltip>
    );
  };
  return <div>{renderNotificationItem(item)}</div>;
}
